import {EmployeeNames} from '../types';
import {
  useModel,
  useValidation,
  validate as v,
  ValidationRules,
} from '@planday-corp/react-model';
import IconButton from '@planday-corp/ui/actions/IconButton';
import TextField from '@planday-corp/ui/forms/fields/TextField';
import Icon from '@planday-corp/ui/icons/Icon';
import {useEffect} from 'react';
import {styled} from 'styled-components';
import {LABELS} from '~/shared/labels/Labels';

interface EmployeeRowProps {
  onChange: ({firstName, lastName}: EmployeeNames) => void;
  employeeNames?: EmployeeNames;
}

const Wrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  width: 100%;
  flex-wrap: nowrap;
`;

const FirstNameField = styled(TextField)`
  flex-basis: calc(0.45 * (100% - 2.5rem));
`;
const LastNameField = styled(TextField)`
  flex-basis: calc(0.55 * (100% - 2.5rem));
`;

const DEFAULT_EMPLOYEE_NAMES = {
  firstName: '',
  lastName: '',
};

const rules: ValidationRules<EmployeeNames> = {
  firstName: [v.required()],
  lastName: [v.required()],
};

export default function EmployeeRow({
  // onChange,
  employeeNames,
}: EmployeeRowProps) {
  const {data, update} = useModel<EmployeeNames>(DEFAULT_EMPLOYEE_NAMES);

  useEffect(() => {
    if (employeeNames) {
      update(employeeNames);
    }
  }, []);

  const {validate, errors} = useValidation(data, rules);

  const PersonIcon = <Icon iconName="person" />;

  return (
    <Wrapper>
      <FirstNameField
        name="firstName"
        onChange={update}
        value={data.firstName}
        prefix={PersonIcon}
        prefixWidth={1.5}
        placeholder={LABELS.firstName}
        error={errors.firstName}
        onBlur={validate}
      />
      <LastNameField
        name="lastName"
        onChange={update}
        value={data.lastName}
        prefix={PersonIcon}
        prefixWidth={1.5}
        placeholder={LABELS.lastName}
        error={errors.lastName}
        onBlur={validate}
      />
      <IconButton
        iconName="closeBig"
        onClick={() => undefined}
        title={LABELS.close}
      />
    </Wrapper>
  );
}
